import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { speedHighlights } from "@/mocks/criacao-sites";

export default function SpeedSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Performance"
          badgeIcon="ri-speed-up-line"
          title="Seu site precisa ser rápido"
          description="Um site moderno precisa carregar rapidamente e proporcionar uma boa experiência principalmente para quem acessa pelo celular."
        />

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_0.9fr] lg:items-center">
          <Reveal>
            <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {speedHighlights.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-700"
                >
                  <i className="ri-flashlight-fill mt-0.5 text-lg text-accent-600" aria-hidden="true"></i>
                  {item}
                </li>
              ))}
            </ul>
            <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
              <i className="ri-information-line mt-0.5 text-base" aria-hidden="true"></i>
              O desempenho final depende também da hospedagem, do conteúdo, das integrações e de outros
              fatores do projeto.
            </p>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-2xl border border-background-200 bg-foreground-950 p-6 text-background-50 md:p-8">
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-wide text-background-400">
                  Experiência do visitante
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500/15 px-3 py-1 text-[11px] font-semibold text-secondary-400">
                  <span className="h-1.5 w-1.5 rounded-full bg-secondary-400"></span>
                  Otimizado
                </span>
              </div>

              <div className="mt-6 flex items-end gap-2">
                {[40, 62, 48, 78, 66, 92].map((height, index) => (
                  <div
                    key={index}
                    className={`w-full rounded-t-md ${
                      index === 5 ? "bg-secondary-400" : "bg-background-50/15"
                    }`}
                    style={{ height: `${height}px` }}
                  ></div>
                ))}
              </div>

              <div className="mt-6 space-y-3">
                <Row icon="ri-smartphone-line" label="Experiência no celular" value="Prioridade máxima" />
                <Row icon="ri-database-2-line" label="Estrutura enxuta" value="Menos peso, mais velocidade" />
                <Row icon="ri-line-chart-line" label="Core Web Vitals" value="Boas práticas aplicadas" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function Row({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-background-50/10 bg-background-50/5 px-4 py-3">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-accent-300">
        <i className={`${icon} text-lg`} aria-hidden="true"></i>
      </span>
      <div className="flex-1">
        <p className="text-[11px] text-background-400">{label}</p>
        <p className="text-sm font-semibold text-background-50">{value}</p>
      </div>
    </div>
  );
}